import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';
import {DEFAULT_SUBMIT_ACTION_TYPE} from '../../../utils/submit';

import {useOptions} from './useOptions';

const defaultSubmitOptions = {
    actionType: DEFAULT_SUBMIT_ACTION_TYPE,
    iconName: 'search',
    isPrimaryAction: true,
    showIcon: undef
};

function useSubmitOptions(props) {
    const {
        submitOptions: propsSubmitOptions
    } = props;

    const {
        options: submitOptions
    } = useOptions(defaultSubmitOptions, propsSubmitOptions);

    const result = {
        submitOptions
    };

    useDebugValue(result);

    return result;
}

export {useSubmitOptions};
